import './css/calendar.css';
/*
    1000 * 60 s>m
    6000 * 60 m>h
   36000 * 24 h>d / 18000 30min / 90000 15min
  864000 * 7  d>w
 6048000      w
24192000      28d
25056000      29d
25920000      30d
26784000      31d
*/

import React from 'react';
import moment from 'moment';

import Util from 'service/util';

const today = Util.getToday();

class Calendar extends React.Component
{
  constructor(props)
  {
    super(props);
    this.state = {
      events: Calendar.indexEvents(props.events),
      month: moment().startOf('month'),
    };
  }

  static indexEvents(events)
  {
    // Index by the calendar date in the source timezone (l_date offset),
    // not by local Date.valueOf(). Otherwise UTC/offset midnight shifts
    // to the previous local day and cells stay empty.
    return (events || []).reduce((r, e) => {
      const src = e.l_date || e.date;
      if (!src) return r;
      const m = moment.parseZone(src);
      if (!m.isValid()) return r;
      const key = m.format('YYYY-MM-DD');
      if (!(key in r)) r[key] = [];
      r[key].push(e);
      return r;
    }, {});
  }

  componentDidUpdate(prevProps)
  {
    if (prevProps.events !== this.props.events)
      this.setState({ events: Calendar.indexEvents(this.props.events) });
  }

  getMonth()
  {
    return moment(this.props.month || this.state.month).startOf('month');
  }

  setPrevMo()
  {
    const month = moment(this.getMonth()).subtract(1, 'month').startOf('month');
    if (!this.props.month) this.setState({ month });
    this.props.onMonthChange?.(month);
  }
  setNextMo()
  {
    const month = moment(this.getMonth()).add(1, 'month').startOf('month');
    if (!this.props.month) this.setState({ month });
    this.props.onMonthChange?.(month);
  }

  renderBody(s,e)
  {
    let elm = [];
    let dct = this.state.events;
    let cur = moment(s);
    let viewMonth = this.getMonth().month();

    while (cur.isSameOrBefore(e))
    {
      let evts = dct[cur.format('YYYY-MM-DD')];
      let d = new Date(cur.valueOf());
      let cn = `xc-day wd-${cur.weekday()}`;
      cn += cur.month() == viewMonth ? ' cur-mo' : ' grey';
      cn += cur.valueOf() == today.valueOf() ? ' today' : '';

      let count = evts?.reduce( (r,x) => (r[x.srv_plan]+=1, r), {A:0,B:0,C:0} );
      if (count) count = `${count.A} / ${count.B} / ${count.C}`;

      elm.push(
        <div key={cur.valueOf()} className={cn} onClick={ e=>this.props.onClickDay?.(d, evts)}>
          <span className="xc-day-name">{ cur.date() }</span>
          <span className="xc-day-evt-cnt">{ count }</span>
        </div>
      );
      cur = cur.add(1, 'd');
    }

    return elm;
  }

  render()
  {
    let mo_s = this.getMonth();
    let mo_e = moment(mo_s).endOf('month');
    let dp_s = moment(mo_s).add(-mo_s.weekday(), 'd');
    let dp_e = moment(mo_e).add(6-mo_e.weekday(), 'd');
    let cn = 'xc-calendar' + (this.props.loading ? ' loading' : '');

    return (
      <div className={cn}>
        <div className="xc-panel">
          <span className="xc-btn prev-mo" onClick={ e=>this.setPrevMo() }>
            { moment(mo_s).add(-1, 'M').format('MMM') }
          </span>
          <span className="xc-lb-cur-mo">{ mo_s.format('YYYY MMM') }</span>
          <span className="xc-btn next-mo" onClick={ e=>this.setNextMo() }>
            { moment(mo_s).add( 1, 'M').format('MMM') }
          </span>
        </div>
        <div className="xc-mo-body">
          <div className="xc-day-head">日</div>
          <div className="xc-day-head">一</div>
          <div className="xc-day-head">二</div>
          <div className="xc-day-head">三</div>
          <div className="xc-day-head">四</div>
          <div className="xc-day-head">五</div>
          <div className="xc-day-head">六</div>
          { this.renderBody(dp_s, dp_e) }
        </div>
      </div>
    );
  } // render



}

export default Calendar;
